/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type CheckDomainHealthSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type CheckDomainHealthRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type CheckDomainHealthSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const CheckDomainHealthSecurity$outboundSchema: z.ZodMiniType<
  CheckDomainHealthSecurity$Outbound,
  CheckDomainHealthSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function checkDomainHealthSecurityToJSON(
  checkDomainHealthSecurity: CheckDomainHealthSecurity,
): string {
  return JSON.stringify(
    CheckDomainHealthSecurity$outboundSchema.parse(checkDomainHealthSecurity),
  );
}

/** @internal */
export type CheckDomainHealthRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const CheckDomainHealthRequest$outboundSchema: z.ZodMiniType<
  CheckDomainHealthRequest$Outbound,
  CheckDomainHealthRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function checkDomainHealthRequestToJSON(
  checkDomainHealthRequest: CheckDomainHealthRequest,
): string {
  return JSON.stringify(
    CheckDomainHealthRequest$outboundSchema.parse(checkDomainHealthRequest),
  );
}
